import isPlainObject from 'lodash-es/isPlainObject';

const GLOBAL_KEY = '__OPTIMIZELY_WEB_DATA__';

export const assignOptimizelyWebData = (key: string, value: unknown) => {
  const existingOptimizelyWebData = (globalThis as any)[GLOBAL_KEY];
  const store = isPlainObject(existingOptimizelyWebData) ? existingOptimizelyWebData : {};
  store[key] = value ?? null;
  (globalThis as any)[GLOBAL_KEY] = store;
};
